import * as z from "zod";
import {
  ReturnOptionsFormSchema,
  ReturnPolicyFormSchema,
} from "./returns-config";

const MAX_POLICY_TEXT_LENGTH = 15_000;

const AnalyzePolicyInputSchema_ = z
  .object({
    policyUrl: z.string().url().optional(),
    policyText: z.string().max(MAX_POLICY_TEXT_LENGTH).optional(),
  })
  .refine((d) => d.policyUrl || d.policyText, {
    message: "Either policyUrl or policyText must be provided",
  });
export const AnalyzePolicyInputSchema: z.ZodType<AnalyzePolicyInput> =
  AnalyzePolicyInputSchema_;
export type AnalyzePolicyInput = {} & z.infer<typeof AnalyzePolicyInputSchema_>;

const AnalyzePolicyOutputSchema_ = z.object({
  returnPolicy: ReturnPolicyFormSchema,
  returnOptions: ReturnOptionsFormSchema,
  rawPolicyText: z.string(),
});
export const AnalyzePolicyOutputSchema: z.ZodType<AnalyzePolicyOutput> =
  AnalyzePolicyOutputSchema_;
export interface AnalyzePolicyOutput extends z.infer<
  typeof AnalyzePolicyOutputSchema_
> {}

export const analyzePolicy = {
  name: "analyzePolicy" as const,
  input: AnalyzePolicyInputSchema,
  output: AnalyzePolicyOutputSchema,
};
